import {useState, Fragment, useContext, useCallback} from 'react'
import {useNavigate, useLocation} from 'react-router-dom'

import {asyncActions} from '../../lib/asyncUtil'
import {connect} from '../../state/hooks/tools'
import {clearSessionTokens} from '../../lib/auth'
import {deleteResource} from '../../lib/asyncMethods'
import {isEmpty} from '../../lib/tools'
import {SIGN_OUT} from '../../state/actionTypes'
import {UserContext} from '../../state/contexts'

import AccountMenu from './AccountMenu'
import AccountTooltip from './AccountTooltip'

const AccountTooltipController = ({user, deleteResource, storeDispatchs, roles}) => {
  const navigate = useNavigate()
  const location = useLocation()
  const {mode, setMode} = useContext(UserContext)
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)
  const role = roles[0] || {}

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const updateMode = useCallback(() => {
    if (mode === 'admin') {
      setMode('user')
      navigate('/dashboard')
    } else {
      setMode('admin')
      navigate('/admin')
    }
  }, [mode])

  const endSession = () => {
    clearSessionTokens()
    setAnchorEl(null)
    Object.values(storeDispatchs).forEach(dispatch => dispatch(asyncActions(SIGN_OUT).success({data: {}})))
    navigate('/auth/sign-in')
  }

  /**
   * The session is torn down after the request rather than before it, which needs the auth token to
   * name the session it is revoking, and torn down whether or not the request landed — a sign-out
   * that leaves tokens behind is one the next visit to the dashboard quietly undoes.
   */
  const signOut = () => {
    deleteResource('auth/sign-out').catch(() => {}).then(endSession)
  }

  const goToSettings = () => {
    if (!location.pathname.includes('account-settings'))
      navigate('/dashboard/account-settings')
  }

  if (!isEmpty(user)) {
    return (
      <Fragment>
        <AccountTooltip user={user} handleClick={handleClick} />
        <AccountMenu
          anchorEl={anchorEl}
          handleClose={handleClose}
          open={open}
          signOut={signOut}
          goToSettings={goToSettings}
          role={role}
          mode={mode}
          handleMode={updateMode}
        />
      </Fragment>
    )
  } else {
    return null
  }
}

/**
 * Both stores spell an absent user as an empty object rather than a missing one, so neither a
 * truthiness check nor `||` can tell a signed-out session from a signed-in one.
 */
const signedInUser = ({auth, users}) => (isEmpty(auth.user) ? users.currentUser : auth.user)

const mapStateToProps = state => ({roles: [], user: signedInUser(state), ...state.roles})

const actionCreators = ({auth, ...dispatchs}) => ({deleteResource: deleteResource(auth, SIGN_OUT), storeDispatchs: {auth, ...dispatchs}})

export default connect(mapStateToProps, actionCreators)(AccountTooltipController)
